import { axiosInstance, baseUrl, handleErrors } from "./auth";

export const UPLOAD_IMAGE = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/common/multipleUploads`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
